import { Fetcher, useMatches, useNavigation } from '@remix-run/react';
import { Modal, ModalProps } from '../Modal';

interface LoadingModalProps extends Omit<ModalProps, 'open'> {
	fetcher?: Fetcher;
	isLoading?: boolean;
	includeLoading?: boolean;
	onlyOnRoute?: string;
}

export function LoadingModal({ fetcher, isLoading, includeLoading, onlyOnRoute, ...modalProps }: LoadingModalProps) {
	const { state } = fetcher || useNavigation();
	const isSubmitting = includeLoading ? ['submitting', 'loading'].includes(state) : state === 'submitting';
	const matches = useMatches();
	const shouldShow = !onlyOnRoute || matches[matches.length - 1]?.pathname === onlyOnRoute;

	return <Modal {...modalProps} open={(isLoading || isSubmitting) && shouldShow} loading={true} />;
}
